import React from "react";

import { TextField } from "../../../_components";

export default function AdditionalDetails({
  translations,
  initialValue,
  setInitialValue,
  monthUpdatedAt,
  setMonthUpdatedAt
}) {

  return (
    <div>
      <TextField
        placeholder={translations.purchase.initial_value_placeholder}
        type={"number"}
        value={initialValue}
        max={10000}
        aria-label="Initial Value"
        onChange={() => setInitialValue(event.target.value)}
      />
      <TextField
        type={"month"}
        value={monthUpdatedAt}
        aria-label="Date Used Last"
        onChange={() => setMonthUpdatedAt(event.target.value)}
      />
    </div>
  );

};
